import { AMAZON_URL, SECTION6, FOOTER } from "../../content/copy";
import { Reveal } from "../Reveal";
import { SplitHeadline } from "../fx/SplitHeadline";
import { SectionMark, Folio, RegMarks } from "../fx/Marginalia";

export const Closing = () => (
  <section id="acquista" className="sec closing bg-a" data-testid="final-cta-section" data-rail="06">
    <RegMarks />
    <div className="frame">
      <SectionMark n="06" label="CHIUSURA" />
      <SplitHeadline as="h2" className="closing-title" text={SECTION6.title} breaks={[3, 1]} indents={[0, 1]} emIdx={[3]} testid="final-title" />
      <div className="g12 closing-prose">
        <div className="prose">
          {SECTION6.paragraphs.map((p, i) => (
            <Reveal as="p" key={i} delay={i * 200} className={i === 0 ? "dropcap dropcap-crimson" : ""} data-testid={`final-paragraph-${i + 1}`}>
              {p}
            </Reveal>
          ))}
        </div>
      </div>
      <div className="manifesto-void">
        <SplitHeadline
          as="p"
          className="manifesto-it"
          text={SECTION6.manifesto}
          breaks={[4, 5, 2, 4, 3]}
          indents={[0, 1, 2, 0, 1]}
          emIdx={[13, 14]}
          testid="final-manifesto"
        />
        <Reveal as="p" className="manifesto-en mono" delay={600} data-testid="final-english-line">{SECTION6.english}</Reveal>
      </div>
      <Reveal className="g12 cta-block">
        <a href={AMAZON_URL} target="_blank" rel="noopener noreferrer" className="btn-cta mono" data-testid="final-amazon-cta">
          {SECTION6.cta}
        </a>
        <p className="cta-sub mono" data-testid="final-cta-subtext">{SECTION6.subtext}</p>
      </Reveal>
      <Folio n="06" />
    </div>
  </section>
);

export const Colophon = () => (
  <footer className="colophon" data-testid="site-footer">
    <div className="frame colophon-inner">
      <span className="mono">{FOOTER}</span>
      <span className="mono colophon-end" aria-hidden="true">FINE TRASMISSIONE · 03:47:12</span>
    </div>
  </footer>
);
